import React, { useState } from 'react';
import Formpopup from './Form-popup';
import { Clock } from 'lucide-react';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';

function Worktogether() {
  const [showPopup, setShowpopup] = useState(false);

  const HandleClose = () => {
    setShowpopup(false);
  };

  return (
    <>
      <div className="together-main">
        <div className="together-inner">
          <Fade top>
            <h2>Let&apos;s Work Together</h2>
          </Fade>

          <Fade bottom>
            <p>
              If you have a website or mobile app idea in mind or you need some
              advice about product design, feel free to contact me. Currently,
              my time books quickly, so the sooner you write, the better it is
              for both of us.
            </p>
          </Fade>

          <Zoom>
            <div className="together-img">
              <Clock size={32} color="#25a6d9" strokeWidth={2} />
            </div>
          </Zoom>

          <Bounce>
            <h4>Reply time: within 1 working day</h4>
          </Bounce>

          <Slide bottom>
            <div className="together-btn">
              <ul>
                <li>
                  <button
                    onClick={() => {
                      window.open(
                        "https://mail.google.com/mail/?view=cm&fs=1&to=muhammadamann72@gmail.com&body=Hi%20Muhammad%2C%0A%0AI%20came%20across%20your%20website%20and%20am%20interested%20in%20working%20with%20you.%20Here's%20a%20brief%20overview%20of%20my%20project%3A%0A%0A-%20[Project%20Details]%0A-%20[Requirements]%0A-%20[Timeline]%0A%0ALooking%20forward%20to%20your%20thoughts!%0A%0ABest%2C%0A[Your%20Name]",
                        '_blank',
                        'width=600,height=400'
                      );
                    }}
                    style={{
                      textDecoration: 'none',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: 14,
                    }}
                  >
                    Write Email
                  </button>
                </li>
              </ul>
            </div>
          </Slide>
        </div>
      </div>

      {showPopup && (
        <Slide bottom>
          <Formpopup onclose={HandleClose} />
        </Slide>
      )}
    </>
  );
}

export default Worktogether;
